var ReifendirektCaptchaAddOnJs = (function ($) {
    var callBackFunctions = {};
    var recaptchaIds = {};
    var sitekey = null;
    var badge = null;
    var invisibleCaptchaEnabled = false;

    var registerCallBackFunction = function(captchaName, callBackFunction) {
        callBackFunctions[captchaName] = callBackFunction;
    };

    var renderRecaptcha = function(captchaName){
        if(typeof grecaptcha === 'undefined'){
            return;
        }
        var id = grecaptcha.render(captchaName, {
            'sitekey' : sitekey,
            'size' : 'invisible',
            'badge' : badge,
            'callback' : callBackFunctions[captchaName]
            });
        recaptchaIds[captchaName] = id;
    };

    var executeRecaptcha = function(captchaName) {
        if(typeof grecaptcha !== 'undefined'){
            grecaptcha.execute(recaptchaIds[captchaName]);
        }
    };
    var getRecaptchaResponse = function(captchaName) {
        if(typeof grecaptcha === 'undefined'){
            return '';
        }
        return grecaptcha.getResponse(recaptchaIds[captchaName]);
    };

    var recaptchaReset = function (captchaName) {
        if(typeof grecaptcha === 'undefined'){
            return '';
        }

        return grecaptcha.reset(recaptchaIds[captchaName]);
    }

    var addSubmitButtonEventListener = function(captchaSelector, captchaName) {
        var submitButton= $(captchaSelector).closest("form").find(':submit');
        if(typeof submitButton !== 'undefined') {
           $(submitButton).on('click', function (e) {
               e.preventDefault();
               recaptchaReset(captchaName)
               grecaptcha.execute(recaptchaIds[captchaName]);
           });
        };
    };

    var init = function(captchaSiteKey, dataBadge) {
        sitekey = captchaSiteKey;
        badge = dataBadge;
        invisibleCaptchaEnabled = true;
    };

    var isInvisibleCaptchaEnabled = function(){
        return invisibleCaptchaEnabled;
    }

    return {
        registerCallBackFunction : registerCallBackFunction,
        executeRecaptcha : executeRecaptcha,
        init : init,
        renderRecaptcha : renderRecaptcha,
        addSubmitButtonEventListener : addSubmitButtonEventListener,
        getRecaptchaResponse : getRecaptchaResponse,
        isInvisibleCaptchaEnabled : isInvisibleCaptchaEnabled,
        recaptchaReset : recaptchaReset
    };

})(jQuery);
